{#each Array(3) as _}
  <div class="rounded-xl bg-white p-4 shadow-sm animate-pulse">
    <div class="flex items-center justify-between gap-3">
      <div class="flex gap-2">
        <div class="h-6 w-16 rounded-full bg-gray-200"></div>
        <div class="h-6 w-20 rounded-full bg-gray-200"></div>
      </div>
      <div class="h-4 w-24 rounded bg-gray-200"></div>
    </div>

    <div class="mt-4 h-5 w-3/4 rounded bg-gray-200"></div>
    <div class="mt-3 h-4 w-full rounded bg-gray-200"></div>
    <div class="mt-2 h-4 w-5/6 rounded bg-gray-200"></div>
    <div class="mt-4 h-4 w-20 rounded bg-gray-200"></div>
  </div>
{/each}
